<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>工作紀錄表</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>工作紀錄表</span></li>
        </ol>
      </div>
    </header>
    <!-- start: page -->
    <div id="tabs-0" class="row">
      <div id="tabs-03" class="row">
        <div class="col-md-12">
          <section class="panel">
            <div class="panel-body">
              <div class="form-group">
                <label class="col-md-2 control-label">學　　號<span style="color:#FF0000;">*</span>：</label>
                <div class="col-md-4">{{item.studentId}}</div>
                <label class="col-md-2 control-label">姓　　名<span style="color:#FF0000;">*</span>：</label>
                <div class="col-md-4">{{item.studentName}}</div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">班　　級<span style="color:#FF0000;">*</span>：</label>
                <div class="col-md-4">{{item.dradeClass}}</div>
                <label class="col-md-2 control-label">服務單位<span style="color:#FF0000;">*</span>：</label>
                <div class="col-md-4">{{item.deptName}}</div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">工讀時間<span style="color:#FF0000;">*</span>：</label>
                <div class="col-md-9">{{item.workDate}} {{item.workStartTime}} 起 {{item.workDate}} {{item.workEndTime}} 止，共計{{item.workTotalHours}}小時</div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">工作項目<span style="color:#FF0000;">*</span>：</label>
                <div class="col-md-9"><textarea style="width:100%" rows="8" v-model="form.content"></textarea></div>
              </div>
              <table width="100%">
                <tr>
                  <td align="center">
                    <a href="#" @click.prevent="formSubmit" class="btn-upload btn" style="background-color:#337AB7; border-color:#2E6DA4; color:#FFF;">送　　出</a>
                  </td>
                </tr>
              </table>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      item: {},
      form: {
        content: ""
      }
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.$http.get("/api/workstudyStudent/workRecord/" + this.id).then(a => {
        this.item = a.body;
        this.form.content = this.item.workContent;
      });
    },
    formSubmit() {
      if (this.checkForm() == false) return;
      this.$http.post("/api/workstudyStudent/workRecord/" + this.id, this.form).then(a => {
        if (a.body.status) {
          alert("儲存成功");
          this.$router.push("/student");
        } else {
          alert(a.body.msg);
          console.log(a.body.exstr);
        }
      });
    },
    checkForm() {
      if (!this.form.content || this.form.content.trim() == "")  {
        alert("『工作項目』尚未填寫");
        return false;
      }
      return true;
    }
  }
};
</script>

<style>
</style>